export const timeFormat = (time: number) => {
  const min = Math.floor(time / 60).toString()
  let sec = (time % 60).toString()
  if (sec.length === 1) {
    sec = `0${sec}`
  }
  return `${min}:${sec}`
}
